import { type FC, useContext } from 'react';

import { useCompleteContractMutation } from '@/api/queries/contract';
import {
  getSpecContractModalToOpen,
  specContractRequirenments,
} from '@/common/config/contract';
import { useExpireContractRefetch } from '@/common/hooks/contract/expire-contract-time';
import {
  type ContractDataType,
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';
import { SpecContractItem } from '@/components/Contract/SpecContractItem/SpecContractItem';
import { ModalContext } from '@/components/Modals/Modal/config';

import { ContractItemAnimationWrapper } from '../ContractItemAnimationWrapper/ContractItemAnimationWrapper';

const ExpiredContractItem: FC<ContractDataType> = (contract) => {
  const { openModal } = useContext(ModalContext);

  const kind = contract.type as SpecContractType | PaidSpecContractType;
  const [, { isUninitialized }] = useCompleteContractMutation({
    fixedCacheKey: 'shared-complete-contract',
  });
  const timeToExpireStatusEnd = useExpireContractRefetch(kind);

  const reqLevel = specContractRequirenments[kind].level;

  return (
    <ContractItemAnimationWrapper isUninitialized={isUninitialized}>
      <SpecContractItem
        kind={kind}
        timeLeft={null}
        contractTimerExtensionDuration={timeToExpireStatusEnd}
        status="expired"
        requairedLevel={reqLevel}
        onClick={() => {
          openModal(getSpecContractModalToOpen(kind, 'expired', contract));
        }}
      />
    </ContractItemAnimationWrapper>
  );
};

export { ExpiredContractItem };
